export default {
      id: "ic-waiting-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic-waiting-usage",
      toString: function () {
        return this.url;
      }
    }